import { EntTypeProductFilter } from "../../../models/filters/TypeProductFilter";
import { EntTypeProduct } from "../../../models/handBooks/typeProduct";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";

export const productTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getProductTypeList: builder.query<ResponseDataGet<EntTypeProduct>, EntTypeProductFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.typeproduct }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getProductTypeById: builder.query<ResponseDataTest<EntTypeProduct>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeproduct }/${ id }`,
		method: 'GET'
	  })
	}),
	addProductType: builder.mutation<ResponseDataTest<EntTypeProduct>, EntTypeProduct>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typeproduct }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editProductType: builder.mutation<ResponseDataTest<EntTypeProduct>, EntTypeProduct>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.typeproduct }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteProductType: builder.mutation<ResponseDataTest<EntTypeProduct>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeproduct }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddProductTypeMutation,
  useDeleteProductTypeMutation,
  useEditProductTypeMutation,
  useLazyGetProductTypeListQuery
} = productTypesApi;
